import { useEffect, useState } from 'react';
import API_ENDPOINTS from '../config/api';

/**
 * The overview counts for one instance (pins, scenarios, datasets,
 * reports, translations, transcripts, …) — what the stage checklists need
 * beyond the instance row and the chain. Admins and the Kuutio's facilitators.
 */
export default function useInstanceOverview(instanceId) {
  const [state, setState] = useState({ overview: null, error: null });
  useEffect(() => {
    if (!instanceId) return undefined;
    let cancelled = false;
    setState({ overview: null, error: null });
    fetch(API_ENDPOINTS.INSTANCE_OVERVIEW(instanceId), { credentials: 'include' })
      .then((r) => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
      .then((overview) => { if (!cancelled) setState({ overview, error: null }); })
      .catch((err) => { if (!cancelled) setState({ overview: null, error: err.message }); });
    return () => { cancelled = true; };
  }, [instanceId]);
  return state;
}
